// extracted by mini-css-extract-plugin
export default {"select":"OrderDropdown_select__YoWqO"};